import React, { useState, useEffect, useRef } from "react"
import { Table, Button, Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"
import { Link } from "react-router-dom"

const AddMaterialItem = () => {
  const formRef = useRef(null)

  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [categories, setCategories] = useState([])
  const [brands, setBrands] = useState([])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const response = await api.post("create-material-item", values)
    if (response.data.success === true) {
      formRef.current.reset()
      setSubmitted(true)
    }
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    const catResp = await api.get("categories")
    const matResp = await api.get("materials")
    setCategories(Array.isArray(catResp.data.data) ? catResp.data.data : catResp.data.data?.data || [])
    setBrands(Array.isArray(matResp.data.data) ? matResp.data.data : matResp.data.data?.data || [])
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Add Material Item</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/materials" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            ref={formRef}
            className="form-horizontal mt-4"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="category"
                    label="Material Category"
                    required
                  >
                    <option value="">Select Category</option>
                    {categories.map((category, i) => (
                      <option key={i} value={category.id}>
                        {category.materialCategory}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField type="select" name="brand" label="Brand" required>
                    <option value="">Select Brand</option>
                    {brands.map((brand, i) => (
                      <option key={i} value={brand.id}>
                        {brand.materialName}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="itemName"
                    label="Material Item Name"
                    value=""
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="itemCode"
                    label="Material Item Code"
                    value=""
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="description"
                    label="Description"
                    value=""
                    type="textarea"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="hsnCode"
                    label="HSN Code"
                    value=""
                    type="text"
                    required
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    name="price"
                    label="Price"
                    value=""
                    type="text"
                    required
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField type="select" name="gst" label="GST Tax %" required>
                    <option value="">Select GST</option>
                    <option value="1">No GST</option>
                    <option value="2">5%</option>
                    <option value="3">12%</option>
                    <option value="4">18%</option>
                    <option value="5">28%</option>
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="unitType"
                    label="Unit Type"
                    required
                  >
                    <option value="">Select Role</option>
                    <option value="1">Admin 1</option>
                    <option value="2">Admin 2</option>
                    <option value="3">Admin 3</option>
                    <option value="4">Admin 4</option>
                  </AvField>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <AvRadioGroup
                    inline
                    name="decimalQty"
                    label="Allow Decimal Quantity"
                    required
                    errorMessage="Pick one!"
                  >
                    <AvRadio label="Yes" value="1" />
                    <AvRadio label="No" value="0" />
                  </AvRadioGroup>
                </div>
              </Col>
            </Row>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Material Item is Added!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Adding...</span>
                    </>
                  ) : (
                    <span>Add Item </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default AddMaterialItem
